/**
 * Created by tking on 19/07/2018.
 */
import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from "@angular/core";
import {MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule} from '@angular/material';
import {ManageIataComponent} from "./manage-iata.component";
import {ManageIataRoutingModule} from "./manage-iata-routing.module";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { ManageDialogComponent } from './manage-dialog/manage-dialog.component';
import {FormsModule} from "@angular/forms";
import {ValidationModule} from "../shared/validation/validation.module";

@NgModule({
  imports: [
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    BrowserModule,
    ManageIataRoutingModule,
    FormsModule,
    ValidationModule
  ],
  declarations: [
    ManageIataComponent,
    ManageDialogComponent
  ],
  providers: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class ManageIataModule { }



// WEBPACK FOOTER //
// ./src/app/manage-iata/manage-iata.module.ts